const styles = (theme) => ({
    transition: {
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    paperAnchor: {
      position: "absolute",
      overflowX: "hidden",
      width: 380,
      boxSizing: "border-box",
      backgroundColor: theme.gridBGColor,
      transform: "translate(0px, 0px)",
      transition: theme.transitions.create(["width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    paperHidden: {
      height: 0,
      width: 0,
    },
    hideDrawerShadow: {
      boxShadow: "none",
    },
    applyDrawerShadow : {
      boxShadow : "0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12)"
    },
    drawerPaper: {
      marginTop: "55px",
      height: "87%",
    },
    backdrop: {
      position: "absolute",
      backgroundColor: "transparent",
    },
    nonTransparentBackdrop: {
      position: "absolute",
    },
    modal: {
      position: "absolute",
    },
  });
  
  export default styles;
  